export default __webpack_public_path__ + "static/media/messageCountIcon.042592e9.svg";